import { IAirlineBrand, ISpecialHandlingCode } from "@cai-services";

export class SpecialHandlingCode implements ISpecialHandlingCode {
  public: boolean;
  shcId: number;
  shcCode: string;
  shcDescription: string;
  airlineBrand: IAirlineBrand;

  constructor (shcCode: string) {
    this.shcCode = shcCode;
  }
}
